import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { projectsData } from '../data/projects';
import './Projects.css';

const Projects = () => {
  const [hovered, setHovered] = useState(null);
  const [filter, setFilter] = useState('All');
  const navigate = useNavigate();

  const categories = ['All', 'Branding', 'Digital Design', 'Print', 'Packaging'];

  const filtered = filter === 'All'
    ? projectsData
    : projectsData.filter(p => p.category === filter);

  return (
    <section className="projects" id="projects">

      <div className="projects-label" data-aos="fade-up">
        <span className="proj-label-line"></span>
        <span className="proj-label-text">My <span>Projects</span></span>
        <span className="proj-label-line"></span>
      </div>

      <div className="filter-tabs" data-aos="fade-up" data-aos-delay="100">
        {categories.map((cat, i) => (
          <button
            key={i}
            className={`filter-btn ${filter === cat ? 'active' : ''}`}
            onClick={() => setFilter(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="projects-list" data-aos="fade-up" data-aos-delay="200">
        {filtered.map((project) => (
          <div
            key={project.id}
            className={`project-row
              ${hovered === project.id ? 'active' : ''}
              ${hovered && hovered !== project.id ? 'dimmed' : ''}`}
            onMouseEnter={() => setHovered(project.id)}
            onMouseLeave={() => setHovered(null)}
            onClick={() => navigate(`/projects/${project.id}`)}
            style={{ cursor: 'pointer', '--pc': project.color }}
          >
            <div className="proj-number">{project.number}</div>
            <div className="proj-main">
              <h3 className="proj-title">{project.title}</h3>
              <p className="proj-desc">{project.desc}</p>
            </div>
            <div className="proj-tags">
              {project.tags.map((tag, j) => (
                <span key={j} className="proj-tag">{tag}</span>
              ))}
            </div>
            <div className="proj-right">
              <span className="proj-category">{project.category}</span>
              <span className="proj-year">{project.year}</span>
              <div className="proj-arrow">→</div>
            </div>
            <div className="proj-line"></div>
          </div>
        ))}
      </div>

      <div className="projects-cta" data-aos="fade-up">
        <p className="cta-text">Interested in working together?</p>
        <a href="#contact" className="cta-btn">
          <span>Let's Talk</span>
          <div className="cta-btn-arrow">→</div>
        </a>
      </div>

    </section>
  );
};

export default Projects;